var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9279 16.8936L21.9267 8.89364C21.9263 8.54292 21.8336 8.19847 21.6581 7.89485C21.4825 7.59123 21.2302 7.33911 20.9264 7.1638L13.9258 3.16486C13.6218 2.98937 13.2769 2.89701 12.9258 2.89707C12.5747 2.89712 12.2298 2.98958 11.9258 3.16517L4.92643 7.16623C4.62272 7.34164 4.37048 7.59383 4.195 7.89751C4.01953 8.20118 3.927 8.54566 3.9267 8.89639L3.92791 16.8964C3.92833 17.2471 4.02096 17.5916 4.19653 17.8952C4.37209 18.1988 4.62441 18.4509 4.92818 18.6262L11.9288 22.6252C12.2329 22.8007 12.5778 22.893 12.9288 22.893C13.2799 22.8929 13.6248 22.8004 13.9288 22.6249L20.9282 18.6238C21.2319 18.4484 21.4841 18.1962 21.6596 17.8925C21.8351 17.5888 21.9276 17.2444 21.9279 16.8936Z",
    stroke: "#5A54A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19727 7.85645L12.928 12.9051L21.6573 7.85379",
    stroke: "#5A54A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9293 22.9745L12.9277 12.8945",
    stroke: "#5A54A3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminLogo);
export default __webpack_public_path__ + "static/media/admin-logo.db3f635a5e98198fcca98307c924d30a.svg";
export { ForwardRef as ReactComponent };